module.exports = "<span class=\"lead-source-colour-sign\" [ngStyle]=\"{'backgroundColor': color, 'border': '1px solid' + borderColor}\"></span>\n"


//////////////////
// WEBPACK FOOTER
// ./shared/components/common/lead-source-color/lead-source-color.html
// module id = ./shared/components/common/lead-source-color/lead-source-color.html
// module chunks = 0